import { Controller } from "@hotwired/stimulus";
import $ from "jquery";

export class FieldArrayController extends Controller {
  static values = {
    max: { type: Number, default: +Infinity },
    min: { type: Number, default: 1 },
    replace: { type: String, default: "NEW_RECORD" },
  };
  static targets = [
    // フィールドの親要素
    "field",
    // <template>
    "template",
    // これの上にフィールドを追加する
    "addHere",
    // 追加ボタン
    "addButton",
    // field内の削除ボタン
    "removeButton",
  ];

  // 有効なフィールドの数
  #count = 0;
  // 非表示にしたフィールド
  #hiddenFields = [];

  connect() {
    this.#count = this.fieldTargets.length;
    for (let i = this.fieldTargets.length; i < this.minValue; i++) {
      this.add();
    }
    this.#update();
  }

  add() {
    if (!this.#isAddable) return;
    this.#count++;

    const html = this.templateTarget.innerHTML.replaceAll(this.replaceValue, String(Date.now()));
    this.addHereTarget.insertAdjacentHTML("beforebegin", html);
    this.#update();
  }

  remove(event) {
    if (!this.#isRemovable) return;

    // 一度削除につかったら以後もう削除をさせない (この削除ボタン連打で他の要素まで消させない)
    if (event.target.disabled) return;
    event.target.disabled = true;

    this.#count--;

    const field = this.fieldTargets.find((field) => field.contains(event.target));
    if (!field) return;
    $(field).slideUp(() => {
      this.#removeField(field);
      this.#update();
    });
  }

  #update() {
    // .indexに番号を入れていく
    this.#visibleFields.forEach((field, i) => {
      const index = i + 1;
      for (const el of field.querySelectorAll(".index")) {
        el.textContent = index;
      }
    });
    // 最大数に達したら追加ボタンを押せなくする
    for (const button of this.addButtonTargets) {
      button.disabled = !this.#isAddable;
      button.ariaDisabled = !this.#isAddable;
    }
    // 最小数に達したら削除ボタンを非表示にする
    for (const button of this.removeButtonTargets) {
      button.classList.toggle("is-hidden", !this.#isRemovable);
    }
  }

  #removeField(field) {
    // idがある場合は消す代わりに_destroyをセットする
    const idInput = field.querySelector("[name$='[id]']");
    const destroyInput = field.querySelector("[name$='[_destroy]']");
    if (idInput?.value && destroyInput) {
      destroyInput.value = "1";
      field.classList.add("is-hidden");
      this.#hiddenFields.push(field);
    } else {
      field.remove();
    }
  }

  get #isAddable() {
    return this.#count < this.maxValue;
  }

  get #isRemovable() {
    return this.#count > this.minValue;
  }

  get #visibleFields() {
    return this.fieldTargets.filter((field) => !this.#hiddenFields.includes(field));
  }
}
